import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ResourcePicker } from "@/components/ResourcePicker";
import { BookOpen, X, ExternalLink, FileDown, PlayCircle, Code2, Image as ImageIcon, Music } from "lucide-react";
import { toast } from "sonner";

const KIND_ICON = { link: ExternalLink, pdf: FileDown, video: PlayCircle, embed: Code2, file: FileDown, image: ImageIcon, audio: Music };

export const HomeworkResources = ({ homeworkId, canEdit = false, compact = false }) => {
  const [items, setItems] = useState([]);
  const [pickerOpen, setPickerOpen] = useState(false);

  const load = async () => {
    try {
      const r = await api.get(`/homework/${homeworkId}/resources`);
      setItems(r.data || []);
    } catch { /* not allowed */ }
  };
  useEffect(() => { if (homeworkId) load(); /* eslint-disable-next-line */ }, [homeworkId]);

  const attach = async (ids) => {
    try {
      await api.post(`/homework/${homeworkId}/resources`, { resource_ids: ids });
      setPickerOpen(false);
      load();
      toast.success("Material agregado a la tarea");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "No se pudo agregar");
    }
  };

  const detach = async (id) => {
    await api.delete(`/homework/${homeworkId}/resources/${id}`);
    load();
  };

  const open = (r) => {
    // Always go through the app so the student sees it inside the platform;
    // from there they can jump to Canva/YouTube/etc. with the "Abrir" button.
    window.open(`${window.location.origin}/dashboard/resources?r=${r.id}`, "_blank", "noopener,noreferrer");
  };

  if (items.length === 0 && !canEdit) return null;

  return (
    <div className={compact ? "mt-2" : "mt-3"} data-testid={`homework-resources-${homeworkId}`}>
      <div className="flex flex-wrap items-center gap-1.5">
        {items.map((r) => {
          const Icon = KIND_ICON[r.kind] || ExternalLink;
          return (
            <span
              key={r.id}
              className="inline-flex items-center gap-1.5 bg-indigo-50 border border-indigo-200 rounded-md px-2 py-1 text-[11px]"
              data-testid={`hw-resource-${r.id}`}
            >
              <Icon className="h-3 w-3 text-indigo-600" />
              <span className="text-slate-800 truncate max-w-[180px]" title={r.title}>{r.title}</span>
              <button type="button" onClick={() => open(r)} className="text-blue-600 hover:underline" data-testid={`hw-resource-open-${r.id}`}>abrir</button>
              {canEdit && (
                <button type="button" onClick={() => detach(r.id)} className="text-slate-400 hover:text-red-600" data-testid={`hw-resource-remove-${r.id}`}>
                  <X className="h-3 w-3" />
                </button>
              )}
            </span>
          );
        })}
        {canEdit && (
          <Button size="sm" variant="outline" className="h-7 text-[11px]" onClick={() => setPickerOpen(true)} data-testid="add-resource-to-homework">
            <BookOpen className="h-3 w-3" /> Agregar de Recursos
          </Button>
        )}
      </div>

      <ResourcePicker
        open={pickerOpen}
        onOpenChange={setPickerOpen}
        selected={[]}
        excludeIds={items.map((i) => i.id)}
        onConfirm={attach}
      />
    </div>
  );
};

export default HomeworkResources;
